import type {
  HTMLProps,
  ReactNode,
} from 'react';

import styled from 'styled-components';

const StyledBackdrop = styled.div({
  position: 'fixed',
  zIndex: 1030,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: '0.4',
});

export const renderBackdrop = (
  props: Omit<HTMLProps<HTMLDivElement>, 'ref' | 'as'>,
): ReactNode => (
  <StyledBackdrop
    {...props}
  />
);
